<div class="content">
  @if (errorMessage) {
    <div class="errorMessage">
      {{ errorMessage }}
    </div>
  }
  <div class="inputRow">
    <mat-form-field class="inputField">
      <mat-label>Quantity</mat-label>
      <input [disabled]="isBusy" type="number" matInput [(ngModel)]="quantity"/>
    </mat-form-field>
    <button matButton="elevated" [disabled]="isBusy || quantity === 0" class="tagsButton" (click)="showTagsDialog()">Set
      Tag Information
    </button>
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button matButton="elevated" class="dialogButton warn-button" [disabled]="isBusy" (click)="cancel()">
      <span>
        <mat-icon class="size-16">cancel</mat-icon>
        <label class="buttonLabel">Cancel</label>
      </span>
    </button>
    <button matButton="elevated" class="dialogButton primary-button" [disabled]="isBusy" (click)="save()">
      <span>
        <mat-icon class="size-16">save</mat-icon>
        <label class="buttonLabel">Save</label>
      </span>
    </button>
  </div>
</div>
